import React, { useState, useRef} from 'react'

import Modal from 'components/Modal'
import RatingComponent from 'components/Rating'

import {
  RatingContainer,
  Comment,
  CommentLabelPrimary,
  CommentLabelSecondary,
  CommentBox,
  Footer,
  FooterText,
  FooterSwitch
} from './styles'

const RatingsModal = ({
  isOpen,
  close,
  onFinish
}) => {

  const [rating, setRating] = useState('')
  const [comment, setComment] = useState('')
  const [isAnonymous, setIsAnonymous] = useState(false)

  const ref = useRef(null)

  const getComment = ({ target: {value} }) => {
    setComment(value)
  }

  const getAnonymous = isAnonymous => {
    setIsAnonymous(isAnonymous)
  }

  const scroll = newRating => {
    ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
    ref.current.focus()
    setRating(newRating)
  }

  const sendRating = () => {
    onFinish({
      rating,
      comment,
      isAnonymous
    })
    setRating('')
  }

  return (
    <Modal
      isOpen={isOpen}
      toggle={close}
      title="Avaliar o Profissional"
      disabled={!rating}
      footer={'Publicar Avaliação'}
      footerClick={sendRating}
      boldHeader
      fontSizeHeader={14}
    >
      <RatingContainer>
        <RatingComponent
          initialRating={rating}
          onChange={scroll}
          ratingTask
          starSize={40}
        />
      </RatingContainer>
      <Comment>
        <CommentLabelPrimary>
          FAÇA UM COMENTÁRIO!
        </CommentLabelPrimary>
        <CommentLabelSecondary>
          Comente sobre a sua experiência! Fale sobre o que você achou do serviço realizado e do profissional que atendeu você:
        </CommentLabelSecondary>
        <CommentBox
          ref={ref}
          value={comment}
          name="comment"
          hasValue={comment}
          onChange={getComment}
          placeholder="Digite seu comentário..."
        />
      </Comment>
      <Footer>
        <FooterText>MANTER COMENTÁRIO ANÔNIMO</FooterText>
        <FooterSwitch
          onChange={getAnonymous}
          checked={isAnonymous}
          offColor={'#C5C5C5'}
          onColor={'#FF7700'}
          offHandleColor={'#F1F1F1'}
          onHandleColor={'#FFA04D'}
          handleDiameter={20}
          uncheckedIcon={false}
          checkedIcon={false}
          height={13}
          width={32}
        />
      </Footer>
    </Modal>
  )
}

export default RatingsModal
